export const toHumanDate = (date: number) => {
    let dateFormat = new Date(date * 1000);
    let day = dateFormat.getDate() > 9  ? dateFormat.getDate() : `0${dateFormat.getDate()}`
    let month = dateFormat.getMonth() + 1 > 9 ? dateFormat.getMonth() + 1 : `0${dateFormat.getMonth() + 1}`
    let humanDate = dateFormat.getFullYear() + "-" + day  + "-" + month
    let time = dateFormat.getUTCHours() +':' + dateFormat.getUTCMinutes() + ':' + (dateFormat.getUTCSeconds() < 10 ? `0${dateFormat.getUTCSeconds()}` : dateFormat.getUTCSeconds())

    return {
        date:  humanDate,
        time : time
    }
}

export const toHumanDateInLocalTimezone = (ISO: string) => {
    if (!ISO) {
        return ''
    }

    const date = new Date(ISO);

    const timestamp = date.getTime();

    const formatDate = (timestamp: number) => {
        const d = new Date(timestamp);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');
        const seconds = String(d.getSeconds()).padStart(2, '0');

        return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
    };

    return formatDate(timestamp);
}




